module.exports = __webpack_public_path__ + "img/defaultRoom.76787b97.png";